import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OneDialogModule, OneSnackBarModule } from '@one/angular-kit/modal';
import { MatListModule } from '@angular/material/list';
import { OneListModule } from '@one/angular-kit/layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { OneTopbarModule } from '@one/angular-kit/navigation';
import { OneIconModule } from '@one/angular-kit/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { OneBottomNavigationModule } from '@one/angular-kit/navigation';
import { CreateNotificationRoutingModule } from './create-notification-routing.module';
import { CreateNotificationComponent } from './create-notification.component';
import { NotificationDocModule } from './notification-doc/notification-doc.module';
import { QnSbnSideNavigationComponent } from './qn-sbn-side-navigation/qn-sbn-side-navigation.component';
import { EditWorkflowComponent } from './edit-workflow/edit-workflow.component';
import { BottomActionBarComponent } from './bottom-action-bar/bottom-action-bar.component';
import { ConfigureFeedbackModule } from './configure-feedback/configure-feedback.module';
import { RecipientslistModule } from './recipientslist/recipients-list.module';
import { FileUploadFeatureModule } from './fileUpload/file-upload.module';
import { OneDialogConfirmationModule } from '@one/angular-kit/modal';
import { MessageAttachmentModule } from './message-attachment/message-attachment.module';
import { DueDateReminderModule } from './due-date-reminder/due-date-reminder.module';
import { RichTextDocumentFeatureModule } from './richTextDocument/rich-text-document.module';
import { AddOwnTemplateDialogModule } from './add-own-template-dialog/add-own-template-dialog.module';
import { NotificationTitleComponent } from './notification-title/notification-title.component';
import { OneFormFieldModule } from '@one/angular-kit/form';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { DailySummaryReportModule } from './daily-summary-report/daily-summary-report.module';

@NgModule({
  declarations: [CreateNotificationComponent, QnSbnSideNavigationComponent, EditWorkflowComponent, BottomActionBarComponent, NotificationTitleComponent],
  exports: [QnSbnSideNavigationComponent],
  imports: [CommonModule, MatListModule, MatDialogModule, OneListModule, MatSidenavModule, ConfigureFeedbackModule, CreateNotificationRoutingModule, OneBottomNavigationModule, OneIconModule, MatMenuModule, MatIconModule, OneTopbarModule, MatButtonModule, MatToolbarModule, RecipientslistModule, AddOwnTemplateDialogModule, FileUploadFeatureModule, OneDialogConfirmationModule, NotificationDocModule, MessageAttachmentModule, RichTextDocumentFeatureModule, OneDialogModule, OneSnackBarModule, DueDateReminderModule, FormsModule, ReactiveFormsModule, OneFormFieldModule, MatFormFieldModule, MatInputModule, MatCardModule, DailySummaryReportModule]
})
export class CreateNotificationModule {}
